import type { Account, InventoryResource, Snapshot } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { MongoAtlasConfiguration } from './steps/mongoAtlasConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface restoreMongoAtlasState {
  resourceId: string;
  snapshot: Snapshot;
  resourceName?: string;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  projectId?: string;
  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags?: boolean;
}

const restoreMongoAtlasFlow: Step<restoreMongoAtlasState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'MongoAtlasConfiguration',
      Component: MongoAtlasConfiguration,
    },
  ],
};

export const RestoreMongoAtlasWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<restoreMongoAtlasState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreMongoAtlasFlow]}
      initialState={{
        snapshot,
        resourceId: resource.id,
        supportedCloudProviders: [Provider.MongoAtlas],
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
      }}
      title={`Restore Mongo Atlas Cluster`}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
